export var CREATE_FORM = "Create final form";
export var UPDATE_FORM = "Update final form";
var FinalFormCreate = /** @class */ (function () {
    function FinalFormCreate(formulario, tipo_solicitud, tipo_recepcion, propiedad, propietarios, representantes, arquitectos, empresas, constructores, constructora, independiente, informe, declaracion, permiso_notariado, cip, proyecto, plazo, antecedentes, caracteristica_proyecto, datos_proyecto, antecedentes_edif, anteproy_condominio, autorizaciones, clasificacion, condiciones, disposicion, disposiciones_esp, normas_urbanisticas, recepcion, recepcion_parcial, registro_bienes, superficie, superficie_anteproyecto, unidades, uso_publico, ampliacion, archivos, Permisos, permisos_recep, permisos_recepciones, idusuario_mongo) {
        this.formulario = formulario;
        this.tipo_solicitud = tipo_solicitud;
        this.tipo_recepcion = tipo_recepcion;
        this.propiedad = propiedad;
        this.propietarios = propietarios;
        this.representantes = representantes;
        this.arquitectos = arquitectos;
        this.empresas = empresas;
        this.constructores = constructores;
        this.constructora = constructora;
        this.independiente = independiente;
        this.informe = informe;
        this.declaracion = declaracion;
        this.permiso_notariado = permiso_notariado;
        this.cip = cip;
        this.proyecto = proyecto;
        this.plazo = plazo;
        this.antecedentes = antecedentes;
        this.caracteristica_proyecto = caracteristica_proyecto;
        this.datos_proyecto = datos_proyecto;
        this.antecedentes_edif = antecedentes_edif;
        this.anteproy_condominio = anteproy_condominio;
        this.autorizaciones = autorizaciones;
        this.clasificacion = clasificacion;
        this.condiciones = condiciones;
        this.disposicion = disposicion;
        this.disposiciones_esp = disposiciones_esp;
        this.normas_urbanisticas = normas_urbanisticas;
        this.recepcion = recepcion;
        this.recepcion_parcial = recepcion_parcial;
        this.registro_bienes = registro_bienes;
        this.superficie = superficie;
        this.superficie_anteproyecto = superficie_anteproyecto;
        this.unidades = unidades;
        this.uso_publico = uso_publico;
        this.ampliacion = ampliacion;
        this.archivos = archivos;
        this.Permisos = Permisos;
        this.permisos_recep = permisos_recep;
        this.permisos_recepciones = permisos_recepciones;
        this.idusuario_mongo = idusuario_mongo;
        this.type = CREATE_FORM;
    }
    return FinalFormCreate;
}());
export { FinalFormCreate };
